import { RouteComponentProps, withRouter } from "react-router";
import React, { ComponentType, FunctionComponent } from 'react';

export function withRouterWorkaround<P extends RouteComponentProps<any>>(Inner: ComponentType<P>) {
  const Wrapped: FunctionComponent<P> = (props: P) => <Inner {...props} />;
  Wrapped.displayName = `WithRouterWorkaround(${Inner.displayName || Inner.name || '?'})`;
  return withRouter(Wrapped);
}
